exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__3la-V{display:none !important}}@media (min-width: 768px){.styles--smUp__3batS{display:none !important}}@media (max-width: 999px){.styles--mdDown__2Dhlr{display:none !important}}.styles--pocket__10FNF{width:250px;margin-left:340px;border-width:1px;border-style:solid;position:fixed;left:50%;bottom:8px;z-index:102;border-radius:2px}@media (max-width: 1199px){.styles--pocket__10FNF{display:none}}.styles--pocketList__1I_Mq{max-height:370px;border-top-width:1px;border-bottom-width:1px;border-style:solid;overflow:auto}.styles--pocketList-remove__1960C{margin:0;padding:0;position:absolute;top:3px;right:5px;cursor:pointer}.styles--pocketPanel__1_COI{cursor:pointer}.styles--pocketBadge__12yuu{min-width:20px;line-height:20px;text-align:center;border-radius:50%}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__3la-V",
	"smUp": "styles--smUp__3batS",
	"mdDown": "styles--mdDown__2Dhlr",
	"pocket": "styles--pocket__10FNF",
	"pocketList": "styles--pocketList__1I_Mq",
	"pocketList-remove": "styles--pocketList-remove__1960C",
	"pocketListRemove": "styles--pocketList-remove__1960C",
	"pocketPanel": "styles--pocketPanel__1_COI",
	"pocketBadge": "styles--pocketBadge__12yuu"
};